import { Expense } from "@finway-group/shared/lib/models"
import { useQuery, UseQueryOptions } from "@tanstack/react-query"

import { queryGet } from "../../utils/reactQuery.utils"
import { CacheEnum } from "../consts"

const MODEL = "expenses"
const staleTime = 60 * 1000
type Options = Omit<UseQueryOptions<Expense>, "queryKey" | "queryFn" | "select" | "staleTime">

export const useExpense = (expenseId: string, opts?: Options) =>
    useQuery({
        ...opts,
        queryKey: [CacheEnum.EXPENSES, expenseId],
        queryFn: () => queryGet(`${MODEL}/${expenseId}`),
        select: (expense: Expense) => new Expense(expense),
        staleTime,
    })
